export const servers = {
  
  real: 'wss://sslsocket.aifanet.com/152.89.36.149/14002'
};
